import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92e970a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main",
  class: "d-flex flex-column align-items-start justify-content-start mx-auto"
}
const _hoisted_2 = { class: "px-2 py-4 w-100" }
const _hoisted_3 = { class: "row mx-0 w-100" }
const _hoisted_4 = {
  class: "col-5 px-0",
  id: "img-outlet-container"
}
const _hoisted_5 = { id: "img-outlet" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"col-7 pr-0 d-flex flex-column justify-content-center\" data-v-92e970a6><div class=\"row mx-0\" data-v-92e970a6><div class=\"col-12 px-0 d-flex justify-content-center\" data-v-92e970a6><img id=\"hl-logo\" src=\"https://dr4y4dqumhrhn.cloudfront.net/healthland_logo.png\" alt=\"HealthLand Logo\" data-v-92e970a6></div></div><div class=\"row mx-0 mt-4\" data-v-92e970a6><div class=\"col-12 px-0 d-flex justify-content-center\" data-v-92e970a6><img id=\"powered-by\" src=\"https://dr4y4dqumhrhn.cloudfront.net/powered_by.png\" alt=\"Powered By\" data-v-92e970a6></div></div></div>", 1)
const _hoisted_8 = { class: "row mx-0 w-100 mt-4" }
const _hoisted_9 = { class: "col-12 px-0" }
const _hoisted_10 = { id: "timer-outer-container" }
const _hoisted_11 = {
  id: "timer-container",
  class: "d-flex justify-content-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/healthland/images/checkout-login/hourglass.png" }, null, -1 /* HOISTED */))
const _hoisted_13 = {
  id: "slot-held",
  class: "ml-4 pt-1"
}
const _hoisted_14 = { class: "row mx-0 w-100 mt-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " Secure your booking instantly with WhatsApp. No password needed! ", -1 /* HOISTED */))
const _hoisted_16 = {
  class: "col-12 px-0 mt-2",
  id: "login-div"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/healthland/images/checkout-login/login.png" }, null, -1 /* HOISTED */))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mx-0 w-100 my-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " --- OR --- ")
], -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mx-0 w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " Button not working? Send this code to +60 19-626 6399 ")
], -1 /* HOISTED */))
const _hoisted_22 = { class: "row mx-2 w-100 mt-4" }
const _hoisted_23 = { class: "col-12 px-0 d-flex justify-content-center" }
const _hoisted_24 = {
  id: "otp",
  class: "pt-2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "btn-copy",
  class: "ml-4",
  src: "/assets/healthland/images/checkout-login/copy.png"
}, null, -1 /* HOISTED */))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mx-0 w-100 mt-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-0 text-center information-text" }, " Do not add extra text. ")
], -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: $data.outlet_image,
              alt: "Outlet Image"
            }, null, 8 /* PROPS */, _hoisted_6)
          ])
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, "SLOT HELD FOR : " + _toDisplayString($options.format_minutes) + " mins", 1 /* TEXT */)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("a", {
            href: `https://api.whatsapp.com/send?phone=60196266399&text=Hi%20HealthLand,%20I%20would%20like%20to%20Login%20with%20this%20WhatsApp%20number.%0A%0AOTP:%20${$data.otp}`,
            target: "_blank",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.track_whatsapp_login_click && $options.track_whatsapp_login_click(...args)))
          }, [..._hoisted_19], 8 /* PROPS */, _hoisted_17)
        ])
      ]),
      _hoisted_20,
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, " OTP: " + _toDisplayString($data.otp), 1 /* TEXT */),
          _createElementVNode("div", {
            class: "d-flex align-items-center",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.copy_otp && $options.copy_otp(...args)))
          }, [..._hoisted_26])
        ])
      ]),
      _hoisted_27
    ])
  ]))
}